import { Model } from '@shared/models/model';
export class NonDrawing extends Model {
  constructor() {
    super();
  }
}
